<template>
  <div class="assets-page-wrapper">
    <!-- 页面标题 -->
    <section class="page-banner assets-banner">
      <!-- 数量为1时，显示单张图片 -->
      <div v-if="bannerSlides.length === 1" class="banner-single-bg">
        <img :src="bannerSlides[0].carouselUrl" class="bg-img">
      </div>

      <!-- 数量大于1时，显示轮播幻灯片 -->
      <div v-else-if="bannerSlides.length > 1" class="banner-slider-bg">
        <div v-for="(slide, idx) in bannerSlides" :key="idx" class="bg-slide" :class="{ active: currentBanner === idx }">
          <img :src="slide.carouselUrl" class="bg-img">
        </div>
      </div>

      <div class="container">
        <h1>资产专区</h1>
        <el-breadcrumb separator="/" class="breadcrumb">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资产专区</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </section>

    <!-- 资产专区导航 -->
    <section class="assets-nav">
      <div class="container">
        <div class="assets-tabs">
          <a v-for="(menu, index) in menuList" :key="menu.id" href="#" class="tab-item" :class="{ active: activeTab === menu.id || (index === 0 && !activeTab) }" @click.prevent="handleTabChange(menu)">
            <i :class="getMenuIcon(menu.name)"></i> {{ menu.name }}
          </a>
        </div>
      </div>
    </section>

    <!-- 筛选区域 -->
    <section class="filter-section">
      <div class="container" style="background: #f5f7fa;padding: 20px;">
        <div class="filter-box" v-if="currentContentTpl === 'sys_content_type_property_01' || currentContentTpl === 'sys_content_type_property_02' || currentContentTpl === 'sys_content_type_auction_01'">
          
          <!-- 搜索 -->
          <div class="filter-row search-row">
            <div class="search-box-assets">
              <input type="text" placeholder="请输入资产名称搜索..." v-model="searchForm.keyword">
              <button class="btn-search" @click="handleSearch"><i class="el-icon-search"></i> 搜索</button>
            </div>
          </div>
          
          <!-- 资产类型 -->
          <div class="filter-row">
               <div class="filter-group">
                 <label>资产类型：</label>
                 <div class="filter-options">
                   <el-radio-group v-model="searchForm.categoryId" size="small">
                     <el-radio label="all">全部</el-radio>
                     <el-radio v-for="value in categoryList" :label="value.dictValue">{{value.dictLabel}}</el-radio>
                   </el-radio-group>
                 </div>
               </div>
               
          </div>
           <div class="filter-row"  v-if="$store.state.siteConfig.showExtData === '1'">
              <div class="filter-group">
                 <label>数据类型：</label>
                 <div class="filter-options">
                   <el-radio-group v-model="searchForm.assetType" size="small">
                     <el-radio label="0">全部</el-radio>
                     <el-radio label="1">辽宁资产</el-radio>
                     <el-radio label="2">外部数据</el-radio>
                   </el-radio-group>
                 </div>
               </div>
           </div>
          <!-- 排序方式 -->
          <div class="filter-row">
            <div class="filter-group">
              <label>排序方式：</label>
              <div class="filter-options">
                <el-radio-group v-model="searchForm.sort" size="small">
                  <el-radio label="default">默认排序</el-radio>
                  <el-radio label="views">按点击热度</el-radio>
                  <el-radio label="time">按发布时间</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="filter-actions">
              <el-button type="primary" class="saixuan" icon="el-icon-set-up" @click="handleSearch">筛选</el-button>
              <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
            </div>
          </div>

        </div>

        <div class="filter-box" v-if="currentContentTpl === 'sys_content_type_news_03' || currentContentTpl === 'sys_content_type_news_04'">
 <!-- 搜索 -->
          <div class="filter-row search-row">
            <div class="search-box-assets">
              <input type="text" placeholder="请输入关键词..." v-model="searchForm.keyword">
              <button class="btn-search" @click="handleSearch"><i class="el-icon-search"></i> 搜索</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 资产列表 -->
    <section class="assets-list-section">
      <div class="container">
        <div class="list-header">
          <div class="result-count">共找到 <strong>{{ totalAssets }}</strong> 条资产信息</div>
        </div>

        <div :class="currentContentTpl === 'sys_content_type_property_01' || currentContentTpl === 'sys_content_type_property_02' || currentContentTpl === 'sys_content_type_auction_01' ? 'assets-grid-detailed' : 'assets-list-detailed'">
          <!-- 第一种样式 (网格卡片) - news_04 -->
          <template v-if="currentContentTpl === 'sys_content_type_property_01' || currentContentTpl === 'sys_content_type_property_02' || currentContentTpl === 'sys_content_type_auction_01'">
            <div class="asset-card-detailed" v-for="(item, index) in assetsList" :key="index">
              <router-link v-if="currentContentTpl === 'sys_content_type_auction_01'" :title="item.assetName" :to="{ path: '/auction/detail', query: { id: item.assetId, from: 'assets', keyword: searchForm.keyword || '', categoryId: searchForm.categoryId || '', assetType: searchForm.assetType || '', sort: searchForm.sort || '' } }" target="_blank">
                <div class="asset-image">
                    <img
                      :src="item.coverImage"
                      style="width: 100%; height: 100%; object-fit: cover;"
                      :defaultimg="currentMenu && currentMenu.defaultImg">
                  <span class="asset-tag tag-recommend" v-if="item.isTop === '1' || item.isTop === 1">
                    <i class="el-icon-top" style="margin-right:2px; font-size: 0.8rem;"></i>Top
                  </span>
                </div>
              </router-link>
              <router-link v-else-if="currentContentTpl === 'sys_content_type_property_01' || currentContentTpl === 'sys_content_type_property_02'" :title="item.assetName" :to="{ path: '/property/detail', query: { id: item.assetId, from: 'assets', keyword: searchForm.keyword || '', categoryId: searchForm.categoryId || '', assetType: searchForm.assetType || '', sort: searchForm.sort || '', isLease: currentContentTpl === 'sys_content_type_property_02' ? '1' : '' } }" target="_blank"> 
               <div class="asset-image">
                  <!-- <img v-if="item.coverImage || (currentMenu && currentMenu.defaultImg)" :src="item.coverImage" :alt="item.title" style="width: 100%; height: 100%; object-fit: cover;">
                  <img v-else src="imgs/default.jpg" style="width: 100%; height: 100%; object-fit: cover;"/> -->
                  <img
                      :src="item.coverImage"
                      style="width: 100%; height: 100%; object-fit: cover;"
                      :defaultimg="currentMenu && currentMenu.defaultImg">
                  <span class="asset-tag tag-recommend" v-if="item.isTop === '1' || item.isTop === 1">
                    <i class="el-icon-top" style="margin-right:2px; font-size: 0.8rem;"></i>Top
                  </span>
                </div>
              </router-link>
              
              <div class="asset-info">
                <router-link :title="item.assetName" style="text-decoration: none;" v-if="currentContentTpl === 'sys_content_type_auction_01'" :to="{ path: '/auction/detail', query: { id: item.assetId, from: 'assets', keyword: searchForm.keyword || '', categoryId: searchForm.categoryId || '', assetType: searchForm.assetType || '', sort: searchForm.sort || '' } }" target="_blank">
                  <h3>{{ item.assetName }}
                     <!-- <span v-if="item.isRecommended === 'Y'" class="tag tag-recommend"><i class="el-icon-star-on" style="margin-right:2px; font-size: 0.8rem;"></i>优质</span> -->

                  </h3>
                </router-link>
                <router-link :title="item.assetName" style="text-decoration: none;" v-else-if="currentContentTpl === 'sys_content_type_property_01' || currentContentTpl === 'sys_content_type_property_02'" :to="{ path: '/property/detail', query: { id: item.assetId, from: 'assets', keyword: searchForm.keyword || '', categoryId: searchForm.categoryId || '', assetType: searchForm.assetType || '', sort: searchForm.sort || '', isLease: currentContentTpl === 'sys_content_type_property_02' ? '1' : '' } }" target="_blank">
                  <h3>{{ item.assetName }}
                    <!-- <span v-if="item.isRecommended === 'Y'" class="tag tag-recommend"><i class="el-icon-star-on" style="margin-right:2px; font-size: 0.8rem;"></i>优质</span> -->
                  </h3>
                </router-link>
            
                <div class="asset-meta">
                  <span v-if="item.location" class="meta-location"><i class="el-icon-location"></i> <span>{{ item.location }}</span></span>
                  <span v-if="item.categoryName" class="meta-category"><i class="el-icon-price-tag" style="margin-top: 4px;"></i> {{ item.categoryName }}</span>
                </div>

                <div class="asset-details2">
                  <div class="detail-item" v-if="item.assetValue && currentContentTpl === 'sys_content_type_auction_01'">
                    <span class="label">起拍价： </span>
                    <span class="value price">{{ item.assetValue }}万元</span>
                    <span style="float: right;" v-if="$store.state.siteConfig.showVisits === '1'"><i class="el-icon-view"></i> {{ item.visits || 0 }}</span>
                  </div>
                  <div class="detail-item" v-if="item.assetValue == null && currentContentTpl === 'sys_content_type_auction_01'">
                    <span class="info-label">起拍价：</span>
                    <span class="info-value price">面议</span>
                    <span style="float: right;" v-if="$store.state.siteConfig.showVisits === '1'"><i class="el-icon-view"></i> {{ item.visits || 0 }}</span>
                  </div>
                  <div class="detail-item" v-if="(currentContentTpl === 'sys_content_type_property_01')">
                    <span class="label"  v-if="item.assetValueType == '1'">参考估值：  ￥{{ item.priceMin }}万元 - {{ item.priceMax }}万元</span>
                    <span class="label"  v-else>参考估值：  面议</span>
                    <span style="float: right;" v-if="$store.state.siteConfig.showVisits === '1'"><i class="el-icon-view"></i> {{ item.visits || 0 }}</span>
                  </div>
                  <div class="detail-item" v-if="(currentContentTpl === 'sys_content_type_property_02')">
                    <span class="label"  v-if="item.rentType === 1">租赁价格：￥{{ item.rentValue }} 万元/年</span>
                    <span class="label"  v-else>租赁价格：  面议</span>
                    <span style="float: right;" v-if="$store.state.siteConfig.showVisits === '1'"><i class="el-icon-view"></i> {{ item.visits || 0 }}</span>
                  </div>
                </div>
<!--                <div class="asset-details2" v-if="item.assetValue || item.priceMin">
                  <div class="detail-item" v-if="item.assetValue && currentContentTpl === 'sys_content_type_auction_01'">
                    <span class="label">起拍价 </span>
                    <span class="value price">{{ item.assetValue }}万元</span>
                  </div>
                  <div class="detail-item" v-if="(currentContentTpl === 'sys_content_type_property_01' || currentContentTpl === 'sys_content_type_property_02')">
                    <span class="label"  v-if="item.assetValueType == '1'">资产价值  ￥{{ item.priceMin }}万元 - {{ item.priceMax }}万元</span>
                    <span class="label"  v-else>资产价值  价格面议</span>
                  </div>
                </div>-->
                <div class="asset-footer">
                  <div class="asset-stats" v-if="$store.state.siteConfig.showVisits === '1'">

                    <span v-if="item.isRecommended === 'Y'" class="tag tag-recommend" style="margin-left: 8px;"><i class="el-icon-star-on" style="margin-right:2px; font-size: 0.8rem;"></i>优质</span>
                    <span v-if="item.isRecommended === 'N'" style="margin-left: 8px;">&nbsp;</span>
                  </div>
                  <span v-else-if="item.isRecommended === 'Y'" class="tag tag-recommend"><i class="el-icon-star-on" style="margin-right:2px; font-size: 0.8rem;"></i>优质</span>
                  <span v-if="item.isRecommended === 'N'"  style="margin-left: 8px;">&nbsp;</span>
                  <router-link :title="item.assetName" v-if="currentContentTpl === 'sys_content_type_auction_01'" :to="{ path: '/auction/detail', query: { id: item.assetId, from: 'assets', keyword: searchForm.keyword || '', categoryId: searchForm.categoryId || '', assetType: searchForm.assetType || '', sort: searchForm.sort || '' } }" target="_blank" class="btn-view">查看详情</router-link>
                  <router-link :title="item.assetName" v-else-if="currentContentTpl === 'sys_content_type_property_01' || currentContentTpl === 'sys_content_type_property_02'" :to="{ path: '/property/detail', query: { id: item.assetId, from: 'assets', keyword: searchForm.keyword || '', categoryId: searchForm.categoryId || '', assetType: searchForm.assetType || '', sort: searchForm.sort || '', isLease: currentContentTpl === 'sys_content_type_property_02' ? '1' : '' } }" target="_blank" class="btn-view">查看详情</router-link>
                  <a v-else href="#" class="btn-view" @click.prevent>查看详情</a>
                </div>
              </div>
            </div>
          </template>

          <!-- 第二、三种样式 (单列列表) - news_03, news_04 -->
          <template v-else>
            <!-- 新闻卡片循环 -->
              <article v-for="(item, index) in assetsList" :key="index" class="news-card">
                <router-link :title="item.title" :to="{ path: '/news/detail', query: { id: item.id, from: 'assets', keyword: searchForm.keyword || '' } }" target="_blank" class="news-thumb">
                  <div class="placeholder-img">
                     <!-- <img :src="item.ico" style="width: 100%; height: 100%; object-fit: cover;"> -->
                    <img
                      :src="item.ico"
                      style="width: 100%; height: 100%; object-fit: cover;"
                      :defaultimg="currentMenu && currentMenu.defaultImg">
                      <span class="new-top" v-if="item.istop === '1' || item.istop === 1">
                        <i class="el-icon-top" style="margin-right:2px; font-size: 14px;"></i>Top
                      </span>
                  </div>
                </router-link>
                <div class="news-body">
                  <h4>
                    <router-link :title="item.title" :to="{ path: '/news/detail', query: { id: item.id, from: 'assets', keyword: searchForm.keyword || '' } }" target="_blank" class="title-link" :style="{color: item.titlecolor != '' ? item.titlecolor:'#333333'}">
                      {{ item.title }}
                      <!-- <span v-if="item.tag" :class="['tag', item.tagClass]">{{ item.tag }}</span> -->
                      <span v-if="item.isrecommend == 1" class="tag tag-recommend"><i class="el-icon-star-on" style="margin-right:2px; font-size: 0.8rem;"></i>推荐</span>
                    </router-link>
                  </h4>
                  <p class="news-summary">{{ item.description }}</p>
                  <div class="news-meta">
                    <span><i class="el-icon-date"></i> {{ item.date }}</span>
                    <span v-if="item.visits && $store.state.siteConfig.showVisits === '1'"><i class="el-icon-view"></i> {{ item.visits }}</span>
                      <span v-if="item.statusLabel && item.statusLabel !== ''" class="status-label"
                        :style="{ color: item.statusColor || '#1e3a5f', backgroundColor: (item.statusColor || '#1e3a5f') + '20' }">
                        {{ item.statusLabel }}
                      </span>
                  </div>
                </div>
              </article>
          </template>
        </div>

        <!-- 暂无数据 -->
        <div v-if="assetsList.length === 0" class="empty-state">
          <el-empty description="暂无资产数据"></el-empty>
        </div>

        <!-- 分页 -->
        <div class="pagination-wrapper" v-if="assetsList.length > 0">
          <el-pagination
            background
            layout="prev, pager, next, jumper"
            :total="totalAssets"
            :page-size="pageSize"
            :pager-count="3"
            :current-page.sync="currentPage"
            @current-change="handlePageChange"
          >
          </el-pagination>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
import { getSubMenuList, getNewsSolrList, getAuctionSolrList, getBannerList, getPropertySolrList, getCategoryList } from '@/api/menu'

export default {
  name: 'Assets',
  data() {
    return {
      activeTab: null,
      menuList: [],
      bannerSlides: [],
      currentBanner: 0,
      bannerTimer: null,
      pcode: this.$route.query.id, // 假设资产专区对应4，具体由实际路由决定
        searchForm: {
          keyword: '',
          categoryId: 'all',
          assetType: '0',
          sort: 'default'
        },
      currentPage: 1,
      pageSize: 10,
      totalAssets: 0,
      assetsList: [],
      currentMenu: null,
      categoryList: []
    }
  },
  watch: {
    '$route.query.id': {
      handler(newId) {
        if (newId) {
          this.pcode = newId
          this.fetchSubMenus()
        }
        
      },
      immediate: false
    }
  },
  created() {
    this.fetchBanner("zczq");
    this.fetchSubMenus();
    this.fetchCategory();
  },
  mounted() {
    this.startBannerTimer();
  },
  beforeDestroy() {
    if (this.bannerTimer) {
      clearInterval(this.bannerTimer);
    }
  },
  computed: {
    activeMenuItem() {
      return this.menuList.find(m => m.id === this.activeTab) || this.menuList[0] || {};
    },
    currentContentTpl() {
      return this.activeMenuItem.contenttpl || '';
    }
  },
  methods: {
    getMenuIcon(name) {
      if (!name) return 'el-icon-collection-tag';
      if (name.includes('推介会')) return 'el-icon-mic';
      if (name.includes('推介')) return 'el-icon-bell';
      if (name.includes('租赁')) return 'el-icon-connection';
      if (name.includes('在拍')) return 'el-icon-gavel';
      if (name.includes('公告')) return 'el-icon-document';
      return 'el-icon-collection-tag';
    },
    startBannerTimer() {
      this.bannerTimer = setInterval(() => {
        if (this.bannerSlides.length > 1) {
          this.currentBanner = (this.currentBanner + 1) % this.bannerSlides.length;
        }
      }, 4000);
    },
    async fetchCategory() {
      try {
        const res = await getCategoryList()
        if (res.code === 0|| res.code === 200) {
          this.categoryList = res.data || []
        } 
      } catch (error) {
        console.error('获取资产类型失败', error)
      }
    },
    async fetchBanner(groupCode) {
      try {
        const res = await getBannerList({ groupCode })
        if (res.code === 0) {
          this.bannerSlides = res.rows || []
        } 
      } catch (error) {
        console.error('获取轮播图失败', error)
      }
    },
    async fetchSubMenus() {
      this.currentPage = 1;
      this.searchForm.keyword = '';
      this.searchForm.categoryId = 'all';
      this.searchForm.assetType = '0';
      this.searchForm.sort = 'default';
      try {
        const res = await getSubMenuList(this.pcode)
        if (res.code === 0) {
          this.menuList = res.rows || []
          if (this.menuList.length > 0) {
            let targetMenu = null;
            if (this.$route.query.contenttpl) {
              targetMenu = this.menuList.find(m => m.contenttpl === this.$route.query.contenttpl);
            }
            if (!targetMenu && this.activeTab) {
              targetMenu = this.menuList.find(m => m.id === this.activeTab);
            }
            if (!targetMenu) {
              targetMenu = this.menuList[0];
            }

            this.currentMenu = targetMenu;
            this.activeTab = targetMenu.id;

            this.pageSize = (targetMenu.listtpl === 'sys_content_type_auction' || targetMenu.listtpl === 'sys_content_type_property') ? 9 : 10;
            if (targetMenu.listtpl == 'sys_content_type_news') {
              this.fetchAssets(targetMenu);
            } else if (targetMenu.listtpl == 'sys_content_type_auction') {
              this.fetchAuction(targetMenu);
            } else if (targetMenu.listtpl == 'sys_content_type_property') {
              this.fetchProperty(targetMenu);
            }
          }
        }
      } catch (error) {
        console.error('获取资产专区二级菜单失败', error)
      }
    },
    handleTabChange(menu) {
       this.searchForm.keyword = '';
       this.searchForm.categoryId = 'all';
       this.searchForm.assetType = '0';
       this.searchForm.sort = 'default';
      this.currentMenu = menu;
      this.activeTab = menu.id;
      this.currentPage = 1;
      
      this.pageSize = (menu.listtpl === 'sys_content_type_auction' || menu.listtpl === 'sys_content_type_property') ? 9 : 10;

      if (menu.listtpl == 'sys_content_type_news') {
        this.fetchAssets(menu);
      } else if (menu.listtpl == 'sys_content_type_auction') {
        this.fetchAuction(menu);
      } else if (menu.listtpl == 'sys_content_type_property') {
        this.fetchProperty(menu);
      }
    },
    async fetchAssets(menu) {
      if (!menu.contenttpl) {
        this.assetsList = [];
        this.totalAssets = 0;
        return;
      }
      try {
         const res = await getNewsSolrList({
           info_type: menu.contenttpl,
           pageNum: this.currentPage,
           keyword: this.searchForm.keyword,
           assetType: this.searchForm.assetType,
           pageSize: this.pageSize
         });
        if (res.code === 0 || res.code === 200) {
          this.assetsList = res.rows || [];
          this.totalAssets = res.total || 0;
        }
      } catch (error) {
        console.error('获取资产列表失败', error);
      }
    },
    async fetchAuction(menu) {
      if (!menu.contenttpl) {
        this.assetsList = [];
        this.totalAssets = 0;
        return;
      }
      try {
        const reqCategoryId = this.searchForm.categoryId === 'all' ? '' : this.searchForm.categoryId;
        let assetTypeValue = this.searchForm.assetType;
        if(this.$store.state.siteConfig.showExtData === '0'){
          assetTypeValue = '1';
        }
        const res = await getAuctionSolrList({
          info_type: '',
          pageNum: this.currentPage,
          keyword: this.searchForm.keyword,
          categoryId: reqCategoryId,
          sort: this.searchForm.sort,
          pageSize: this.pageSize,
          assetType: assetTypeValue,
        }); 
        if (res.code === 0 || res.code === 200) {
          this.assetsList = res.rows || [];
          this.totalAssets = res.total || 0;
        }
      } catch (error) {
        console.error('获取资产列表失败', error);
      }
    },
    async fetchProperty(menu) {
      if (!menu.contenttpl) {
        this.assetsList = [];
        this.totalAssets = 0;
        return;
      }
      try {
        let isLease = "";
        if (menu.contenttpl == 'sys_content_type_property_02') {
          isLease = "1";
        }
        const reqCategoryId = this.searchForm.categoryId === 'all' ? '' : this.searchForm.categoryId;
        let assetTypeValue = this.searchForm.assetType;
        if(this.$store.state.siteConfig.showExtData === '0'){
          assetTypeValue = '1';
        }
        const res = await getPropertySolrList({
          isLease: isLease,
          pageNum: this.currentPage,
          keyword: this.searchForm.keyword,
          categoryId: reqCategoryId,
          assetType: assetTypeValue,
          sort: this.searchForm.sort,
          pageSize: this.pageSize
        });
        if (res.code === 0 || res.code === 200) {
          this.assetsList = res.rows || [];
          this.totalAssets = res.total || 0;
        }
      } catch (error) {
        console.error('获取资产列表失败', error);
      }
    },
  
    handleSearch() {
      if (this.currentMenu.listtpl == 'sys_content_type_news') {
        this.fetchAssets(this.currentMenu);
      } else if (this.currentMenu.listtpl == 'sys_content_type_auction') {
        this.fetchAuction(this.currentMenu);
      } else if (this.currentMenu.listtpl == 'sys_content_type_property') {
        this.fetchProperty(this.currentMenu);
      }
    },
    resetSearch() {
       this.searchForm = {
         keyword: '',
         categoryId: 'all',
         assetType: '0',
         sort: 'default'
       };
      this.$message.info('搜索条件已重置');
    },
    handlePageChange(page) {
      this.currentPage = page
      this.handleSearch()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-blue: #1a3a5c;
$hover-blue: #1e6fa2;
$accent-red: #c0392b;
$light-bg: #ffffff;
$border: #e8edf3;
$text-main: #333;
$text-secondary: #666;
$text-light: #999;
.title-link:hover {
  color: #1a3a5c !important;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ---- Banner 头图 ---- */
.page-banner {
  background-size: cover;
  background-color: $primary-blue;
  color: #fff;
  padding: 60px 0;
  position: relative;


  .banner-single-bg, .banner-slider-bg {
    position: absolute;
    inset: 0;
    z-index: 0;
  }

  .bg-slide {
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.8s ease;
    &.active { opacity: 1; }
  }

  .bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .container {
    position: relative;
    z-index: 2;
  }

  h1 {
    font-size: 2.2rem;
    font-weight: 600;
    margin: 0 0 15px 0;
    letter-spacing: 2px;
  }
  
  ::v-deep .el-breadcrumb__inner,
  ::v-deep .el-breadcrumb__separator {
    color: rgba(255, 255, 255, 0.8) !important;
  }
  ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: #fff !important;
  }
}

/* ---- 资产专区导航 ---- */
.assets-nav {
  padding: 24px 0;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;

  .assets-tabs {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    &::-webkit-scrollbar { display: none; }

    .tab-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      font-size: 0.95rem;
      color: #333333;
      background-color: #f5f7fa;
      border-radius: 4px;
      text-decoration: none;
      transition: all 0.2s ease;
      border: none;
      white-space: nowrap;

      i { 
        font-size: 1.1rem; 
        color: #606266; 
        transition: color 0.2s; 
      }

      &:hover {
        background-color: #1a3a5c;
        color: #fff;
        i { color: #fff; }
      }

      &.active {
        background-color: $primary-blue;
        color: #ffffff;
        font-weight: 600;
        border-bottom: none;
        i { color: #ffffff; }
      }
    }
  }
}

/* ---- 筛选区域 ---- */
.filter-section {
  padding: 30px 0;
  background: #fff;
  border-bottom: 1px solid #eaeef3;
}

.filter-box {
  display: flex;
  flex-direction: column;
  gap: 15px;

  .filter-row {
    display: flex;
    align-items: center;
    border-bottom: 1px dashed $border;
    padding-bottom: 15px;

    &.search-row {
      border-bottom: none;
      padding-bottom: 5px;
    }

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
      justify-content: space-between;
    }
  }
}

.search-box-assets {
  display: flex;
  width: 100%;
  max-width: 600px;
  border: 1px solid $border;
  border-radius: 4px;
  overflow: hidden;

  input {
    flex: 1;
    border: none;
    padding: 12px 15px;
    outline: none;
    font-size: 0.95rem;
    background: $light-bg;
  }

  .btn-search {
    background: $primary-blue;
    color: #fff;
    border: none;
    padding: 0 25px;
    cursor: pointer;
    font-size: 0.95rem;
    transition: background 0.2s;
    &:hover { background: $hover-blue; }
  }
}

.filter-group {
  display: flex;
  align-items: flex-start;

  label {
    width: 80px;
    color: $text-main;
    font-weight: 500;
    margin-top: 5px;
    flex-shrink: 0;
  }

  .filter-options {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    align-items: center;
    margin-top: 5px;
    ::v-deep .el-radio {
      margin-right: 20px;
      margin-top: 5px;
      margin-bottom: 5px;
      font-weight: normal;
    }
  }
}
::v-deep .el-radio__input.is-checked+.el-radio__label {
    color: $primary-blue;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: $primary-blue;
    background: $primary-blue;
}
.filter-actions {
  display: flex;
  gap: 10px;
  .saixuan {
    background-color:$primary-blue ;
  }
}

/* ---- 全局标签样式 ---- */
.tag-recommend {
  background: linear-gradient(135deg, #ffaa00 0%, #e4393c 100%);
  color: #fff;
  border: none;
  font-weight: 600;
  padding: 2px 7px;
  display: inline-flex;
  align-items: center;
  box-shadow: 0 2px 5px rgba(228, 57, 60, 0.25);
  border-radius: 4px;
  font-size:12px;
}

/* ---- 资产列表区域 ---- */
.assets-list-section {
  padding: 40px 0;
  background: $light-bg;
}

.list-header {
  margin-bottom: 25px;
  
  .result-count {
    color: $text-secondary;
    font-size: 0.95rem;
    strong { color: $primary-blue; font-size: 1.1rem; margin: 0 4px; }
  }
}

.assets-grid-detailed {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.asset-card-detailed {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.04);
  transition: all 0.3s;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 8px 20px rgba(0,0,0,0.08);
    transform: translateY(-5px);
  }

  .asset-image {
    width: 100%;
    height: 200px;
    position: relative;
    
    .placeholder-img {
      width: 100%; height: 100%;
      position: relative;
      background: #e9ecef;
      display: flex; align-items: center; justify-content: center;
      i { font-size: 3rem; color: #ced4da; }
    }
    .asset-tag {
        position: absolute; top: 10px; left: 10px;
        padding: 2px 10px; border-radius: 4px;
        font-size: .75rem; font-weight: 600; color: #fff;
        &.tag-recommend {
          background: transparent;
          color: #dbb523;
          border: none;
          font-weight: 700;
          padding: 3px 10px;
          display: inline-flex;
          border-radius: 4px;
          font-size: 0.8rem;
        }
      }
  }

  .asset-info {
    padding: 15px;
    display: flex;
    flex-direction: column;
    flex: 1;

    h3 {
      font-size: 15px;
      margin: 0 0 10px 0;
      color: $text-main;
      line-height: 1.4;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      height: 42px; /* Fix line clamp height jumping */
      .tag {
        display: inline-block;
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 12px;
        margin-left: 8px;
        vertical-align: middle;
        font-weight: normal;

        &.tag-urgent { background: #ffeaea; color: #c0392b; border: 1px solid #ffcccc; }
        &.tag-end { background: #f0f2f5; color: #909399; border: 1px solid #dcdfe6; }
        &.tag-notice { background: #e6f7ff; color: #1890ff; border: 1px solid #91d5ff; }
        &.tag-promo { background: #fff7e6; color: #fa8c16; border: 1px solid #ffd591; }
        &.tag-recommend {
          background: transparent;
          color: #dbb523;
          border: none;
          font-weight: 700;
          padding: 3px 10px;
          display: inline-flex;
          align-items: center;
          box-shadow: 0 2px 8px rgba(255, 140, 0, 0.4);
          border-radius: 4px;
          text-shadow: 0 1px 2px rgba(0,0,0,0.2);
          font-size: 0.8rem;
        }
      }
    }

    .asset-meta {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      font-size: 0.8rem;
      color: $text-secondary;

      .meta-location {
        display: flex;
        align-items: center;
        gap: 4px;
        background: $light-bg;
        padding: 3px 8px;
        border-radius: 4px;
        max-width: 150px;
        flex: 1;
        min-width: 0;
        span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .meta-category {
        display: flex;
        align-items: center;
        gap: 4px;
        background: $light-bg;
        padding: 3px 8px;
        border-radius: 4px;
        flex-shrink: 0;
        margin-left: 10px;
      }
    }
    .asset-details2 {
        font-size: 12px;
        color: $text-light;
        border-top: 1px solid #e0e0e0;
        // border-bottom: 1px solid #e0e0e0;
        padding: 5px;
    }
    .asset-details {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px;
      margin-bottom: 15px;

      .detail-item {
        display: flex;
        flex-direction: column;
        
        .label { font-size: 12px; color: $text-light; margin-bottom: 2px; }
        .value { 
          font-size: 0.85rem; color: $text-main; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; 
          &.price { color: $accent-red; font-size: 0.95rem; font-weight: 600; }
        }
      }
    }

    .asset-footer {
      margin-top: auto;
      border-top: 1px solid $border;
      padding-top: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .asset-stats {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;
        font-size: 12px;
        color: $text-light;
      }

      .btn-view {
        background: #fff;
        color: $primary-blue;
        border: 1px solid $primary-blue;
        padding: 5px 12px;
        border-radius: 4px;
        text-decoration: none;
        font-size: 0.85rem;
        transition: all 0.2s;

        &:hover {
          background: $primary-blue;
          color: #fff;
        }
      }
    }
  }
}

/* ---- 单列列表板式 ----- */
/* ---- 列表项 ---- */
.placeholder-img>.new-top {
  position: absolute;
  top: 5%;
  left: 5px;
  color: #dbb523;
  border: none;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  font-size: 0.8rem;
  z-index: 2;
  .el-icon-top {
    color: #dbb523 !important;
  }
}
.news-items-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.news-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  gap: 20px;
  border: 1px solid transparent;
  transition: all 0.3s;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  margin-bottom:20px;

  &:hover {
    box-shadow: 0 8px 24px rgba(0,0,0,0.08);
    border-color: rgba($primary-blue, 0.1);
    transform: translateY(-2px);
  }

  .news-thumb {
    width: 200px;
    height: 130px;
    flex-shrink: 0;
    border-radius: 6px;
    overflow: hidden;

    .placeholder-img {
      width: 100%; height: 100%;
      position: relative;
      background: #e9ecef;
      display: flex; align-items: center; justify-content: center;
      i { font-size: 3rem; color: #ced4da; }
    }
  }

  .news-body {
    flex: 1;
    display: flex;
    flex-direction: column;

    h4 {
      margin: 0 0 10px 0;
      font-size: 18px;
      line-height: 1.4;

      a {
        color: $primary-blue;
        text-decoration: none;
        transition: color 0.2s;
        &:hover { color: $hover-blue; }
      }

      .tag {
        display: inline-block;
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 12px;
        margin-left: 8px;
        vertical-align: middle;
        font-weight: normal;

        &.tag-urgent { background: #ffeaea; color: #c0392b; border: 1px solid #ffcccc; }
        &.tag-end { background: #f0f2f5; color: #909399; border: 1px solid #dcdfe6; }
        &.tag-notice { background: #e6f7ff; color: #1890ff; border: 1px solid #91d5ff; }
        &.tag-promo { background: #fff7e6; color: #fa8c16; border: 1px solid #ffd591; }
        &.tag-recommend {
          background: linear-gradient(135deg, #ffaa00 0%, #e4393c 100%);
          color: #fff;
          border: none;
          font-weight: 600;
          padding: 2px 7px;
          display: inline-flex;
          align-items: center;
          box-shadow: 0 2px 5px rgba(228, 57, 60, 0.25);
          border-radius: 4px;
        }
      }
    }

    .news-summary {
      font-size: 0.95rem;
      color: $text-secondary;
      line-height: 1.6;
      margin: 0 0 8px 0;
      flex: 1;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .news-meta {
      display: flex;
      gap: 20px;
      font-size: 0.85rem;
      color: $text-light;

      span {
        display: flex;
        align-items: center;
        gap: 5px;
      }

      .status-label {
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 12px;
        margin-left: 8px;
        vertical-align: middle;
        font-weight: normal;
      }
    }
  }
}
    
/* 分页 */
.pagination-wrapper {
  margin-top: 30px;
  padding: 15px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}
::v-deep {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #1e3a5f !important;
  }
}
.empty-state {
  background: #fff;
  padding: 50px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}

/* ================== 响应式适配 ================== */

/* Pad / Small Desktop */
@media (max-width: 1024px) {
  .assets-grid-detailed {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 850px) {
  .assets-grid-detailed {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 767px) {
  .page-banner {
    padding: 30px 0;
    h1 { font-size: 1.6rem; }
  }

  .assets-nav .assets-tabs .tab-item {
    padding: 10px 15px;
    font-size: 0.9rem;
  }

  /* 筛选区排列优化 */
  .filter-box .filter-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding-bottom: 12px;

    &:last-child {
      flex-direction: column;
    }
  }

  .filter-group {
    flex-direction: row;
    width: 100%;
    align-items: flex-start;
    
    label { 
      margin-bottom: 0; 
      width: 75px; 
      margin-top: 6px; 
      font-size: 0.9rem;
      color: #333;
      white-space: nowrap;
    }
    
    .filter-options { 
      width: calc(100% - 75px); 
      gap: 6px; 
      
      /* 将单选框变为移动端友好的标签样式 */
      ::v-deep .el-radio {
        margin-right: 8px;
        margin-top: 2px;
        margin-bottom: 6px;
        padding: 5px 12px;
        border-radius: 15px;
        background: #f0f2f5;
        border: none;
        
        .el-radio__input {
          display: none;
        }
        
        .el-radio__label {
          padding-left: 0;
          font-size: 0.85rem;
          color: #666;
        }
        
        &.is-checked {
          background: rgba(26, 58, 92, 0.1);
          .el-radio__label {
            color: #1a3a5c;
            font-weight: 600;
          }
        }
      }
    }
  }

  .filter-actions {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 5px;
    gap: 20px;
    
    .el-button {
      flex: 1;
      max-width: 140px;
    }
  }

  .search-box-assets input { padding: 10px; }
  .btn-search { padding: 0 15px; }

  /* 列表单列，上下堆叠 */
  .assets-grid-detailed {
    grid-template-columns: 1fr;
  }
  
  .asset-card-detailed {
    flex-direction: column;
    
    .asset-image {
      width: 100%;
      height: 200px;
    }
    
    .asset-info {
      padding: 15px;
      h3 { 
        height: auto; 
        font-size: 15px;
        margin-bottom: 15px;
       .tag {
        display: inline-block;
        font-size: 12px;
        padding: 2px 8px;
        border-radius: 12px;
        margin-left: 8px;
        vertical-align: middle;
        font-weight: normal;

        &.tag-urgent { background: #ffeaea; color: #c0392b; border: 1px solid #ffcccc; }
        &.tag-end { background: #f0f2f5; color: #909399; border: 1px solid #dcdfe6; }
        &.tag-notice { background: #e6f7ff; color: #1890ff; border: 1px solid #91d5ff; }
        &.tag-promo { background: #fff7e6; color: #fa8c16; border: 1px solid #ffd591; }
        &.tag-recommend {
          background: linear-gradient(135deg, #ffaa00 0%, #e4393c 100%);
          color: #fff;
          border: none;
          font-weight: 600;
          padding: 2px 7px;
          display: inline-flex;
          // align-items: center;
          // box-shadow: 0 2px 5px rgba(228, 57, 60, 0.25);
          border-radius: 4px;
        }
      }
      }
      .asset-meta { margin-bottom: 12px; flex-wrap: wrap; gap: 8px; }
      .asset-details { display: grid; } /* 恢复细节展示 */
      .asset-footer { padding-top: 12px; }
    }
  }

  /* 普通单行新闻卡片改为上下堆叠 */
  .news-card {
    flex-direction: column;
    gap: 15px;
    padding: 15px;

    .news-thumb {
      width: 100%;
      height: 180px;
    }
  }
}
</style>
